export default {"src":"/_next/static/media/success.f860e082.gif","height":150,"width":150};